var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('DocumentHeader',{attrs:{"header":"แก้ไขใบส่งคืนสินค้า","link_back":"stock/document/returnproductreceipt"}}),_c('Government_receipt_edit')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }